<template>
	<div class="ocx" style="width:100%;height:97%;margin: 0 auto">
		<!-- <?IMPORT NAMESPACE = CUSTOM IMPLEMENTATION = "#FormPost" />
		<CUSTOM:KTSEDocAxExForm id="KTSEDocAxExForm"></CUSTOM:KTSEDocAxExForm> -->
		<div id="mainObject"  style="width:90%;height:100%;display: inline-block">
			<OBJECT width="100%" height="100%" id="control" classid="clsid:5CAC43BD-DE74-49F9-9FD6-DDA6B5A15A9C" codebase="KTSEDocAxEx.ocx"></OBJECT>
			<OBJECT id="FormPost" classid="clsid:019A29FA-4B5D-4FE8-82D4-51C554285457" name="FormPost"></OBJECT>
		</div>
		<div style="width:8%;display: inline-block;vertical-align: top" id="toolBar">
			<!-- <button type="button" value="打开文件" @click="OpenFileDlg">
			<button type="button" value="加载文件" @click="LoadPDFDocument">
			<button type="button" value="加载EDC文件" @click="LoadEDCDocument"> -->
			<button :disabled="loading" type="button" class="ocxBtn btn btn-primary"  @click="DealStamp" v-if="showDealStamp!=false">盖章</button>
			<button :disabled="loading" type="button" class="ocxBtn btn btn-primary"  @click="DealLotStamp">批量盖章</button>
			<button :disabled="loading" type="button" class="ocxBtn btn btn-primary"  @click="DealHandSign">签批</button>
			<button :disabled="loading" type="button" class="ocxBtn btn btn-primary"  @click="DealUnStamp">撤销</button>
			<button :disabled="loading" type="button" class="ocxBtn btn btn-primary"  @click="DealVerifyStamp">验证</button>
			<!-- <button type="button" class="ocxBtn btn btn-primary"  value="保存提交" @click="SendFile"> -->
			<button :disabled="loading" type="button" class="ocxBtn btn btn-primary"  @click="saveAndUpload">保存提交</button>
			<!-- <button type="button" class="ocxBtn btn btn-primary"  @click="DealFileExportBlack">抄送</button> -->
			<!-- <button type="button" class="ocxBtn btn btn-primary"  @click="DealFilePrint">打印</button> -->
			<button :disabled="loading" type="button" class="ocxBtn btn btn-primary"  @click="DealAdminStamp">印章管理</button>
			<button :disabled="loading" type="button" class="ocxBtn btn btn-primary"  @click="DealAdminOption">系统设置</button>
			<button :disabled="loading" type="button" class="ocxBtn btn btn-primary"  @click="CloseDocument">退出</button>
		</div>
	</div>
</template>

<script>
import { bucketName } from "@/resources.js"
import { API_SecSeal, API_Common, API_CONST, API_Video } from "@/api/api.js"
import { getRandomNum } from "@/tool/parse.js"

export default {
	props: ["rpx", "id", "isView", "uploadInfo", "sealInfo", "type" ,"showDealStamp","dataObj"],
	data() {
		return {
			loading: false,
			isFromSupervisorEnd: false, //isFromSupervisorEnd是否从监管端来的盖章文件
			bind: { filePath: "", sealStr: "", sealFilePath: "", fileName: "" },
			res: false,
			client: {},
			returnId: null,
            num:""
		}
	},
	mounted() {
		let me = this;
		console.log("ocx mounted")
		let hideFun = this.hideFun;
		this.sealInfo.params["rpx"] = this.rpx;
		this.sealInfo.params["recordId"] = this.id;
		API_SecSeal.seal(this.sealInfo.controllName, this.sealInfo.method, this.sealInfo.params).then(res => {
			if (res.id != null) {
				this.returnId = res.id;
				this.$emit("passSealId", res.id)
			}
			if (res.result == true || res.result == "true") {
				this.bind.filePath = res.data.filePath; //盖章的pdf
				this.bind.fileName = res.data.fileName;
				this.isFromSupervisorEnd = (res.type ? res.type === "getFromSupervisorEnd" : false);
				this.res = true;
				try {
					let client = new OSS.Wrapper({
						region: 'oss-cn-hangzhou',
						//云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，部署在服务端使用RAM子账号或STS，部署在客户端使用STS。
						accessKeyId: API_CONST.accessKeyId,
						accessKeySecret: API_CONST.accessKeySecret,
						bucket: API_CONST.bucketName
					});
					this.client = client;

					//获取签章的打开地址
					let url = this.bind.filePath;
					if (this.isFromSupervisorEnd) {//从监管的来的数据，要转换+头
						url = API_CONST.SupervisorSecSealURL + this.bind.filePath.replace(/\\\\/g, "/");
					} else {
						if (!url.startsWith("http")) {
							// 可能是阿里的oss
							let suffix = (url.substring(url.lastIndexOf(".") + 1, url.length) == "pdf" ? "pdf" : "edc");
							let fileName = url.substring(0, url.lastIndexOf("."));
							url = this.client.signatureUrl(url, {
								response: {
									'content-disposition': 'attachment; filename="' + fileName + "." + suffix + '"'
								}
							})
						}
					}
					// 打开签章文件
					if(res.type == "createPdf"){
						this.LoadPDFDocument(url);
					}else{
						this.LoadEDCDocument(url);
					}
					this.getNum();
				}
				catch (ex) {
				}
			} else {
			    let message = res.message != null ? res.message : "系统出错请稍后再试";
				alert(message);
				this.CloseDocument();

				// this.$alert(res.message != null ? res.message : "系统出错请稍后再试", "错误", {
				// 	confirmButtonText: "确定",
				// 	type: "error"
				// })

			}
		})
	},
	methods:{
		OpenFileDlg(){
			//打开文件；
			let fileurl = control.OpenFileDlgA();
			setTimeout("control.PDFCommand(13)",500);
			control.SetPrintable(true);
		},
		LoadPDFDocument(url){
			//加载PDF文件；
			// console.log("打开的PDF文件地址为："+url)
			control.LoadDocument(url);
			control.PDFCommand(13);      //以适合宽方式展示文件
		},
		LoadEDCDocument(url){
			//加载EDC文件；
			// console.log("打开的EDC文件地址为："+url)
			control.LoadEDCDocument(url);
			control.PDFCommand(13);    //以适合高方式展示文件
		},
		DealStamp(){
			// 盖章；
			let bool=control.IsDealStamp();
			if(bool){
				control.DealStamp();
				this.SealNO();
			}
			else{
				alert("不能进行盖章,请先导入PDF文件！")
				// this.$alert('不能进行盖章,请先导入PDF文件！', '', {
				// 	confirmButtonText: '确定',
				// 	type: 'warning'
				// });
			}
		},
		DealLotStamp(){
			//批量盖章；
			let bool=control.IsDealLotStamp();
			if(bool){
				control.DealLotStamp();
			}
			else{
				alert("不能进行批量盖章,请先导入PDF文件！")
				// this.$alert('不能进行批量盖章,请先导入PDF文件！', '', {
				// 	confirmButtonText: '确定',
				// 	type: 'warning'
				// });
			}
		},
		DealHandSign(){
			//签批；
			let bool=control.IsDealHandSign();
			if(bool){
				control.DealHandSign();
			}
			else{
				alert("不能进行签批,请先导入PDF文件！")
				// this.$alert('不能进行签批,请先导入PDF文件！', '', {
				// 	confirmButtonText: '确定',
				// 	type: 'warning'
				// });
			}
		},
		DealUnStamp(){
		//撤销；
			let bool=control.IsDealUnStamp();
			if(bool){
				control.DealUnStamp();
			}
			else{
				alert("请先进行盖章操作！")
				// this.$alert('请先进行盖章操作！', '', {
				// 	confirmButtonText: '确定',
				// 	type: 'warning'
				// });
			}
		},
		DealVerifyStamp(){
			//验证；
			let bool=control.IsDealVerifyStamp();
			if(bool){
				control.DealVerifyStamp();
			}
			else{
				alert("验证失败！")
				// this.$alert('验证失败！', '', {
				// 	confirmButtonText: '确定',
				// 	type: 'warning'
				// });
			}
		},
		SendFile(){
			// 上传;
			FormPost.ClearAllFiles(true);     //清除表单数据，为true时会删除本地文件
			OAForm.submit();                    //上传文件
		},
    	DealFileExportBlack(){
			//抄送；
			let bool=control.IsDealFileExportBlack();
			if(bool){
				control.DealFileExportBlack("c:/test.bdc");
			}
			else{
				alert("请加载EDC文件！")
				// this.$alert('请加载EDC文件！', '', {
				// 	confirmButtonText: '确定',
				// 	type: 'warning'
				// });
			}
		},
    	DealFilePrint(){
			//打印；
			let bool=control.IsDealFilePrint();
			if(bool){
				//control.DealFilePrint("false");    //设置默认为纸张大小打印方式
				let result = control.DealFilePrint("");    //弹出打印窗口进行打印
			}
			else{
				alert("不能进行打印！")
				// this.$alert('不能进行打印！', '', {
				// 	confirmButtonText: '确定',
				// 	type: 'warning'
				// });
			}
    	},
		DealAdminStamp(){
			//印章管理；
			control.DealAdminStamp();
		},
		DealAdminOption(){
		//系统设置；
			control.DealAdminOption();
		},
		CloseDocument(){
			//关闭文件；
			control.SetToolButtonVis(1048576);    //屏蔽工具条上的打印按钮
			control.CloseDocument();
			this.$emit("closeOCX", { success: true, op: "close" })
		},
        getNum(){
            let b = control.GetSealCount(0);       //获取edc文件中盖章总个数
            this.num = b;
        },
		SealNO(){
			let a = control.GetAllCount(0);        //获取edc文件中签章总个数（盖章+签批）
			let b = control.GetSealCount(0);       //获取edc文件中盖章总个数
			let c = control.GetHandSignCount(0);   //获取edc文件中签批总个数
			console.log('签章总数为'+a+'个。'+'\n'+'电子印章总数为'+b+'个。'+'\n'+'签批总数为'+c+'个。');
			return b>this.num;
		},
		// 转为base64+上传
		saveAndUpload(){
			//输出EDC文件并输出B64编码；
			control.SetDocSignType(1);    //edc文件输出方式,0默认,1签名,2加密
			//control.preIsDealUnStamp();   //撤消没盖章下去的印章
			//control.DelSaveDlg(1);        //保存时不弹出保存成功的提示
			let bool=control.IsDealUnStamp();
			if(bool){
				if(this.SealNO()){
					control.DealFileExport("000");       //文件保存在临时目录中，并随机命名
					this.loading = true;
					this.uploadFile(control.GetEDCB64() )
				}else{
					alert("请先盖章。")
					// this.$alert('请先盖章或添加签批。', '', {
					// 	confirmButtonText: '确定',
					// 	type: 'warning'
					// });
				}
			}
			else{
				alert("请先盖章或添加签批。")
				// this.$alert('请先盖章或添加签批。', '', {
				// 	confirmButtonText: '确定',
				// 	type: 'warning'
				// });
			}
		},
		//上传签章文件
		uploadFile(base64) {
			let me = this;
			// let fileName = getRandomNum(16);
			// secSign/签章文件上传成功后回调的接口controllerName/报表模版名称/年/月/日/pdf的名字.edc
			// let key = "secSign/" + me.uploadInfo.controllName + "/" + this.rpx + "/" + date.getFullYear() + "/" + (month > 9 ? month : '0' + month) + "/" + (day > 9 ? day : '0' + day) + "/" + fileName + ".edc";
			// console.log(this.client.multipartUpload == null)

			let fileName;
			let filePath = "";
			if (this.bind.filePath.startsWith("current")) {
				filePath = "supervisorSecSeal/";
				fileName = this.bind.filePath;
			} else {
				filePath = this.bind.filePath.substring(0, this.bind.filePath.lastIndexOf("/") + 1);
				fileName = this.bind.fileName.split(".")[0] + '.edc';
			}
			try {
				let file = new File([this.convertBase64UrlToBlob(base64)], fileName);
				this.client.multipartUpload(filePath + fileName, file, {}).then(function(res) {
					let id = ""
					if (me.id != "" && me.id != null) {
						id = me.id;
					} else if (me.returnId != null) {
						id = me.returnId;
					}
                    let params = {};
                    if(me.uploadInfo.method ==  "personLeaveSPFirst" || me.uploadInfo.method ==  "personLeaveSPFinal"){
                        params = { id: id, fileName: fileName, filePath: filePath + fileName, displayName: fileName, fileSuffix: "edc" ,data:me.dataObj};
                    }else {
                        params = { id: id, fileName: fileName, filePath: filePath + fileName, displayName: fileName, fileSuffix: "edc" }
                    }
                  if (me.uploadInfo.method === 'confirmBackFun') {
                    if (me.uploadInfo.controllName == 'videoRemove') {
                      API_Video.confirmVideoRemove(me.sealInfo.params).then(res => {
                        if (res.success) {
                          API_Common.post(me.uploadInfo.controllName, me.uploadInfo.method, params).then(res => {
                            // 返回url后可能还有后续操作，写在各自的函数里
                            if (res.success) {
                              me.$notify({
                                message: "签章文件上传成功",
                                type: "info",
                                offset: document.body.clientHeight - 200,
                                duration: 2000,//设置为0则不fengu自动关闭
                              });
                              me.uploadcomplete();
                            } else {
                              this.$alert('签章文件上传出错，请稍候再次上传', '', {
                                confirmButtonText: '确定',
                                type: "error"
                              });
                              this.$emit("closeSecSeal", { success: false, op: "close" })
                            }
                          })
                        } else {
                          this.$alert('签章文件上传出错，请稍候再次上传', '', {
                            confirmButtonText: '确定',
                            type: "error"
                          });
                          this.$emit("closeSecSeal", { success: false, op: "close" })
                        }
                      });
                    } else {
                      API_Video.confirmVideoPause(me.sealInfo.params).then(res => {
                        if (res.success) {
                          API_Common.post(me.uploadInfo.controllName, me.uploadInfo.method, params).then(res => {
                            // 返回url后可能还有后续操作，写在各自的函数里
                            if (res.success) {
                              me.$notify({
                                message: "签章文件上传成功",
                                type: "info",
                                offset: document.body.clientHeight - 200,
                                duration: 2000,//设置为0则不fengu自动关闭
                              });
                              me.uploadcomplete();
                            } else {
                              this.$alert('签章文件上传出错，请稍候再次上传', '', {
                                confirmButtonText: '确定',
                                type: "error"
                              });
                              this.$emit("closeSecSeal", { success: false, op: "close" })
                            }
                          })
                        } else {
                          this.$alert('签章文件上传出错，请稍候再次上传', '', {
                            confirmButtonText: '确定',
                            type: "error"
                          });
                          this.$emit("closeSecSeal", { success: false, op: "close" })
                        }
                      });
                    }
                  } else {
                    API_Common.post(me.uploadInfo.controllName, me.uploadInfo.method, params).then(res => {
                      // 返回url后可能还有后续操作，写在各自的函数里
                      if (res.success) {
                        me.$notify({
                          message: "签章文件上传成功",
                          type: "info",
                          offset: document.body.clientHeight - 200,
                          duration: 2000,//设置为0则不fengu自动关闭
                        });
                        me.uploadcomplete();
                      } else {
                        this.$alert('签章文件上传出错，请稍候再次上传', '', {
                          confirmButtonText: '确定',
                          type: "error"
                        });
                        this.$emit("closeSecSeal", { success: false, op: "close" })
                      }
                    })
                  }
				});
			} catch (ex) {
				console.log("使用后台上传文件的方法", ex)
				// 使用后台上传文件的方法
				this.uploadByJava(filePath , fileName, base64);
				// this.$alert("IE浏览器或360浏览器的兼容模式不支持文件上传，请使用谷歌浏览器、360浏览器的“极速模式”。", "错误", {
				// 	confirmButtonText: "确定",
				// 	type: "error"
				// })
			}
		},
		uploadByJava(filePath , fileName, base64 ) {
			console.log("uploadByJava")
			let me = this;
			// console.log(key);
			// console.log(base64);
			API_Common.uploadByJava({ data: base64, key: filePath + fileName }).then(ubj => {
				if (ubj.success) {
					let id = ""
					if (me.id != "" && me.id != null) {
						id = me.id;
					} else if (me.returnId != null) {
						id = me.returnId;
					}
                    let params = {};
                    if(me.uploadInfo.method ==  "personLeaveSPFirst" || me.uploadInfo.method ==  "personLeaveSPFinal"){
                        params = { id: id, fileName: fileName, filePath: filePath + fileName, displayName: fileName, fileSuffix: "edc" ,data:me.dataObj};
                    }else {
                        params = { id: id, fileName: fileName, filePath: filePath + fileName, displayName: fileName, fileSuffix: "edc" }
                    }
                  if (me.uploadInfo.method === 'confirmBackFun') {
                    if (me.uploadInfo.controllName == 'videoRemove') {
                      API_Video.confirmVideoRemove(me.sealInfo.params).then(res => {
                        if (res.success) {
                          API_Common.post(me.uploadInfo.controllName, me.uploadInfo.method, params).then(res => {
                            // 返回url后可能还有后续操作，写在各自的函数里
                            if (res.success) {
                              me.$notify({
                                message: "签章文件上传成功",
                                type: "info",
                                offset: document.body.clientHeight - 200,
                                duration: 2000,//设置为0则不fengu自动关闭
                              });
                              me.uploadcomplete();
                            } else {
                              this.$alert('签章文件上传出错，请稍候再次上传', '', {
                                confirmButtonText: '确定',
                                type: "error"
                              });
                              this.$emit("closeSecSeal", { success: false, op: "close" })
                            }
                          })
                        } else {
                          this.$alert('签章文件上传出错，请稍候再次上传', '', {
                            confirmButtonText: '确定',
                            type: "error"
                          });
                          this.$emit("closeSecSeal", { success: false, op: "close" })
                        }
                      });
                    } else {
                      API_Video.confirmVideoPause(me.sealInfo.params).then(res => {
                        if (res.success) {
                          API_Common.post(me.uploadInfo.controllName, me.uploadInfo.method, params).then(res => {
                            // 返回url后可能还有后续操作，写在各自的函数里
                            if (res.success) {
                              me.$notify({
                                message: "签章文件上传成功",
                                type: "info",
                                offset: document.body.clientHeight - 200,
                                duration: 2000,//设置为0则不fengu自动关闭
                              });
                              me.uploadcomplete();
                            } else {
                              this.$alert('签章文件上传出错，请稍候再次上传', '', {
                                confirmButtonText: '确定',
                                type: "error"
                              });
                              this.$emit("closeSecSeal", { success: false, op: "close" })
                            }
                          })
                        } else {
                          this.$alert('签章文件上传出错，请稍候再次上传', '', {
                            confirmButtonText: '确定',
                            type: "error"
                          });
                          this.$emit("closeSecSeal", { success: false, op: "close" })
                        }
                      });
                    }
                  } else {
                    API_Common.post(me.uploadInfo.controllName, me.uploadInfo.method, params).then(res => {
                      // 返回url后可能还有后续操作，写在各自的函数里
                      if (res.success) {
                        me.$notify({
                          message: "签章文件上传成功",
                          type: "info",
                          offset: document.body.clientHeight - 200,
                          duration: 2000,//设置为0则不fengu自动关闭
                        });
                        me.uploadcomplete();
                      } else {
                        this.$alert('签章文件上传出错，请稍候再次上传', '', {
                          confirmButtonText: '确定',
                          type: "error"
                        });
                        this.$emit("closeSecSeal", { success: false, op: "close" })
                      }
                    })
                  }
				} else {
					alert("签章文件上传出错，请稍候再次盖章")
					// this.$alert(ubj.msg,'签章文件上传出错，请稍候再次盖章' , {
					// 	confirmButtonText: '确定',
					// 	type: "error"
					// });
					this.$emit("closeSecSeal", { success: false, op: "close" })
				}
			})
		},
		uploadcomplete() {
			this.$emit("ocxUploadcomplete")
		},
		convertBase64UrlToBlob(base64) {
			let bytes = window.atob(base64); //去掉url的头，并转换为byte
			//处理异常,将ascii码小于0的转换为大于0
			let ab = new ArrayBuffer(bytes.length);
			let ia = new Uint8Array(ab);
			for (let i = 0; i < bytes.length; i++) {
				ia[i] = bytes.charCodeAt(i);
			}
			return new Blob([ab]);
		}
	}
}
</script>

<style>
.ocxBtn{
	display:block;
	margin:10px 15px 0;
	font-size: 16px;
	width:110px;
	height: 30px;
}
</style>



// WEBPACK FOOTER //
// ocx.vue?6db881ac